// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "blank_votes_count": {
      "column": {
        "default": 0,
        "name": "blank_votes_count",
        "null": false,
        "type": "integer"
      },
      "name": "blank_votes_count",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "VoteElectionPostResult",
  "collectionKey": "vote_election_post_results",
  "collectionName": "vote_election_post_results",
  "i18nKey": "vote_election_post_result",
  "camelizedLower": "voteElectionPostResult",
  "name": "VoteElectionPostResult",
  "nameDasherized": "vote-election-post-result",
  "pluralName": "vote_election_post_results",
  "ransackable_associations": [
    {
      "className": "ElectionPost",
      "collectionName": "election_posts",
      "foreignKey": "election_post_id",
      "name": "election_post",
      "macro": "belongs_to",
      "resource_name": "ElectionPost",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "VoteElectionPostContactResult",
      "collectionName": "vote_election_post_contact_results",
      "foreignKey": "vote_election_post_result_id",
      "name": "vote_election_post_contact_results",
      "macro": "has_many",
      "resource_name": "VoteElectionPostContactResult",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "blank_votes_count",
      "column": {
        "default": 0,
        "name": "blank_votes_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "election_post_id",
      "column": {
        "default": null,
        "name": "election_post_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_election_post_id",
      "column": {
        "default": null,
        "name": "old_election_post_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [],
  "paramKey": "vote_election_post_result",
  "primaryKey": "id"
}

/** Frontend model for VoteElectionPostResult. */
export default class VoteElectionPostResult extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {number} */
  blankVotesCount() {
    return this.readAttributeUnderscore("blank_votes_count")
  }

  /** @returns {boolean} */
  hasBlankVotesCount() {
    const value = this.blankVotesCount()

    return this._isPresent(value)
  }
}
